import React from "react";
import logger from "logger";
import { getStyleJSON } from "Utils/Common";

export default function(props) {
  return (
    <div style={{ padding: "7px" }}>
      <div
        align="center"
        style={getStyleJSON("color: red; font-size: 10px;margin-top:10px;")}
      >
        {props.children}
      </div>
    </div>
  );
}
